
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/netzwerk/locations/create",
      function () {
        return require("private-next-pages/netzwerk/locations/create.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/netzwerk/locations/create"])
      });
    }
  